const localizers = {
  'loading.msg': () => `Nalaganje ...`,
  'logon.message.msg': () => `Potrebno je preverjanje pristnosti. Vnesite veljavni ID uporabnika in geslo.`,
  'logon.button.msg': () => `Prijava ...`,
  'SASServer.logonError.msg': () => `Prijava v strežnik ni mogoča.`,
  'SASServer.genericError.msg': () => `Strežnika ni mogoče doseči.`,
}
export default localizers;
